import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon';

import type { IconType } from '../../types';

const IconName = 'Issue';

const IconSvg = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M14.605 15.6656C13.3811 16.6565 11.8224 17.25 10.125 17.25C6.18997 17.25 3 14.06 3 10.125C3 6.18997 6.18997 3 10.125 3C14.06 3 17.25 6.18997 17.25 10.125C17.25 11.8224 16.6565 13.3811 15.6656 14.605L20.7803 19.7197C21.0732 20.0126 21.0732 20.4874 20.7803 20.7803C20.4874 21.0732 20.0126 21.0732 19.7197 20.7803L14.605 15.6656ZM15.75 10.125C15.75 13.2316 13.2316 15.75 10.125 15.75C7.0184 15.75 4.5 13.2316 4.5 10.125C4.5 7.0184 7.0184 4.5 10.125 4.5C13.2316 4.5 15.75 7.0184 15.75 10.125Z" fill="currentColor"/>
    <path d="M9.621 11.292L9.0435 6.651H11.553L10.9545 11.292H9.621ZM9.2535 13.875V11.9325H11.3325V13.875H9.2535Z" fill="currentColor"/>
  </svg>
`;

const IssueIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.605 15.6656C13.3811 16.6565 11.8224 17.25 10.125 17.25C6.18997 17.25 3 14.06 3 10.125C3 6.18997 6.18997 3 10.125 3C14.06 3 17.25 6.18997 17.25 10.125C17.25 11.8224 16.6565 13.3811 15.6656 14.605L20.7803 19.7197C21.0732 20.0126 21.0732 20.4874 20.7803 20.7803C20.4874 21.0732 20.0126 21.0732 19.7197 20.7803L14.605 15.6656ZM15.75 10.125C15.75 13.2316 13.2316 15.75 10.125 15.75C7.0184 15.75 4.5 13.2316 4.5 10.125C4.5 7.0184 7.0184 4.5 10.125 4.5C13.2316 4.5 15.75 7.0184 15.75 10.125Z'
      fill='currentColor'
    />
    <path
      d='M9.621 11.292L9.0435 6.651H11.553L10.9545 11.292H9.621ZM9.2535 13.875V11.9325H11.3325V13.875H9.2535Z'
      fill='currentColor'
    />
  </SvgIcon>
);

export default {
  name: IconName,
  title: IconName,

  IconComponent: IssueIcon,
  IconSvg: IconSvg
} as IconType;
